import { styles } from "../../../utils/styles/products-leasing-styles";
import Box from "@mui/material/Box";
import { useI18n } from "@/i18n/I18nProvider";
import PageHead from "@/components/PageHead";
import PageCover from "@/components/PageCover";
import dynamic from "next/dynamic";
import { getProductsText } from "../../../../locales/products";

const IconTileSection = dynamic(
  () => import("../../../components/mini-components/IconTileSection.jsx"),
  {
    ssr: false,
    loading: () => (
      <Box
        className="horizontal-safe-padding vertical-safe-padding"
        sx={{
          bgcolor: "white",
          width: "100%",
        }}
      >
        {/* Reserved space to prevent CLS */}
        <Box sx={{ height: { xs: 260, md: 340 }, width: "100%" }} />
      </Box>
    ),
  }
);

const Outro = dynamic(() => import("@/components/mini-components/Outro"), {
  ssr: false,
  loading: () => (
    <Box className="horizontal-safe-padding vertical-safe-padding">
      <Box sx={{ height: { xs: 180, md: 240 }, width: "100%" }} />
    </Box>
  ),
});

export default function Index() {
  const { t, locale } = useI18n();
  const products = getProductsText(locale);

  return (
    <>
      <PageHead
        title={t.pages_main_tags.productsBusiness.leasing.title}
        description={t.pages_main_tags.productsBusiness.leasing.meta_desc}
      />

      <Box sx={styles.container}>
        {/* PageCover is likely LCP: keep it loaded/SSR to improve LCP */}
        <PageCover
          color={products.leasing.cover.color}
          img={products.leasing.cover.img}
          title1={products.leasing.cover.title1}
          title2={products.leasing.cover.title2}
          description={products.leasing.cover.description}
          formType="b"
          product="leasing"
          source={42}
        />

        <Box
          className="horizontal-safe-padding vertical-safe-padding"
          sx={{
            bgcolor: "white",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: { xs: "center", lg: "space-between" },
            alignItems: "center",
            textAlign: { xs: "center", md: "initial" },
            gap: { xs: 3, md: 4 },
          }}
        >
          {/* If unused, remove this Box completely. Keeping it as a placeholder only wastes layout work */}
          {/* <Box sx={{ maxWidth: "700px" }} /> */}

          <IconTileSection page="leasing" />
        </Box>

        <Outro outro={products.leasing.outro} bgColor="#f8f8f8" />
      </Box>
    </>
  );
}
